import { action, Action } from 'typesafe-actions'

import { ErrorState, ErrorTypes } from './types'

export const showError = (payload: ErrorState): Action => action(ErrorTypes.SHOW_ERROR, payload)

export const clearError = (): Action => action(ErrorTypes.CLEAR_ERROR)
